"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var useEfficientDragLayer_1 = __importDefault(require("./useEfficientDragLayer"));
var DragAround = function (_a) {
    var _b, _c, _d, _e;
    var children = _a.children, innerRef = _a.innerRef, dragging = _a.dragging, preTransform = _a.preTransform, postTransform = _a.postTransform, animation = _a.animation, props = __rest(_a, ["children", "innerRef", "dragging", "preTransform", "postTransform", "animation"]);
    var transitionProperty = (_c = (_b = animation === null || animation === void 0 ? void 0 : animation.properties) === null || _b === void 0 ? void 0 : _b.join(', ')) !== null && _c !== void 0 ? _c : 'transform';
    var transition = react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition-property: ", ";\n    will-change: ", ";\n    transition-duration: ", "s;\n    transition-timing-function: ", ";\n  "], ["\n    transition-property: ", ";\n    will-change: ", ";\n    transition-duration: ", "s;\n    transition-timing-function: ", ";\n  "])), transitionProperty, transitionProperty, (_d = animation === null || animation === void 0 ? void 0 : animation.seconds) !== null && _d !== void 0 ? _d : 0.2, (_e = animation === null || animation === void 0 ? void 0 : animation.timingFunction) !== null && _e !== void 0 ? _e : 'ease-in-out');
    var collect = react_2.useCallback(function (monitor) { return monitor.getDifferenceFromInitialOffset(); }, []);
    var offset = useEfficientDragLayer_1.default(collect);
    var translation = dragging && offset ? "translate3d(" + Math.round(offset.x) + "px, " + Math.round(offset.y) + "px, 0)" : '';
    var transform = react_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["transform: ", " ", " ", ""], ["transform: ", " ", " ", ""])), preTransform, translation, postTransform);
    return (jsx_runtime_1.jsx("div", __assign({ ref: innerRef, css: [style, transition, transform, dragging && draggingStyle] }, props, { children: children }), void 0));
};
var style = react_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  will-change: transform;\n"], ["\n  will-change: transform;\n"])));
var draggingStyle = react_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  transition: none;\n  z-index: 1000 !important;\n  pointer-events: none;\n"], ["\n  transition: none;\n  z-index: 1000 !important;\n  pointer-events: none;\n"])));
exports.default = react_2.forwardRef(function (props, ref) { return jsx_runtime_1.jsx(DragAround, __assign({ innerRef: ref }, props), void 0); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=DragAround.js.map